import { Route, Routes } from 'react-router-dom';
import Wrap from '../../hoc/Wrap';
import VaccineResult from './VaccineResult';
import PhysicalAndDrugScreen from './PhysicalAndDrugScreen/PhysicalAndDrugScreen';
import WorkStatus from './WorkStatus';
import RxntPrescriptionsResult from './RxntPrescriptionsResult';

const ResultContainer = () => {

  return (
    <Wrap>
      <Routes>
        <Route path="/vaccine" key={0} element={<VaccineResult />} />
        <Route path="/physical-drug-screens" key={1} element={<PhysicalAndDrugScreen />} />
        <Route path="/physical-drug-screens/:filter" key={2} element={<PhysicalAndDrugScreen />} />
        <Route path="/workstatus" key={0} element={<WorkStatus />} />
        <Route path="/rxnt-prescriptions" element={<RxntPrescriptionsResult />} />
        

      </Routes>



    </Wrap>
  );
};






export default ResultContainer;